import { render, staticRenderFns } from "./AddTOTPMethodForm.vue?vue&type=template&id=3193be8f&scoped=true"
import script from "./AddTOTPMethodForm.vue?vue&type=script&lang=ts"
export * from "./AddTOTPMethodForm.vue?vue&type=script&lang=ts"
import style0 from "./AddTOTPMethodForm.vue?vue&type=style&index=0&id=3193be8f&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193be8f",
  null
  
)

export default component.exports